import { render } from "./CompanySelector.vue?vue&type=template&id=a27198be&scoped=true"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"

import "./CompanySelector.vue?vue&type=style&index=0&id=a27198be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27198be"]])

export default __exports__